export default "__VITE_ASSET__D$hEBTsR__"